import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import TwoCol from '../../partials/TwoCol'
import '../../sass/innerPages.sass'
import MainTitle from '../../partials/MainTitle'
import brb from '../../img/brb.jpg'
import brbscr from '../../img/brbscr.jpg'
import brbFont from '../../img/soaFont.jpg'

function Brb() {
  const { t } = useTranslation();
  
  useEffect(()=>{
    window.scrollTo(0, 0);
  },[])

  return (
    <div className='container'>
      <MainTitle title={t('brbTitle')} />
      <TwoCol contentOne={<ContentOne />} contentTwo={<ContentTwo />} />
      <div className='txtContainer mt-50 px-20'>
        <h2>{t('designDecisions')}</h2>
        <p><Trans i18nKey="brbDDTxt"></Trans></p>
        <figure>
          <img className='image-fluid' src={brbFont} alt="Typescale" />
          <figcaption>Boat Rentals Brač font</figcaption>
        </figure>
        <ul className='colors'>
          <li><span className='color' style={{background: "#444D59"}}></span> #444D59</li>
          <li><span className='color' style={{background: "#3C9AAF"}}></span> #3C9AAF</li>
          <li><span className='color' style={{background: "#A68C76"}}></span> #A68C76</li>
          <li><span className='color' style={{background: "#C6AD97"}}></span> #C6AD97</li>
          <li><span className='color' style={{background: "#F6FBFD"}}></span> #F6FBFD</li>
        </ul>

        <h2>{t('designSystem')}</h2>
        <p><Trans i18nKey="brbDSTxt"></Trans></p>

        <h2>{t('uxApproach')}</h2>
        <p><Trans i18nKey="brbUXTxt" components={{ul: <ul />, li: <li />}}>
        The primary UX goal was to simplify the process of exploring boats, excursions, and booking information while maintaining an exciting and visually engaging experience. The structure was designed to help users quickly browse available boats, understand rental options, and access contact or reservation actions with minimal friction.
        <br /><br />Special attention was given to:
        <ul>
          <li>clear boat presentation</li>
          <li>intuitive navigation flow</li>
          <li>simplified booking experience</li>
          <li>visually engaging layouts</li>
          <li>strong call-to-action hierarchy</li>
        </ul>
        The experience was designed to feel effortless, modern, and closely connected to the lifestyle and atmosphere of Adriatic travel.
        </Trans></p>

        <h2>{t('visualDirection')}</h2>
        <p><Trans i18nKey="brbVDTxt"></Trans></p>

        <h2>{t('figmaScr')}</h2>
        <figure>
          <img className='image-fluid' src={brbscr} alt={t('figmaScr')} />
          <figcaption>{t('brbScrCaption')}</figcaption>
        </figure>

        <h2>{t('finalOutcome')}</h2>
        <p><Trans i18nKey="brbFOTxt"></Trans></p>

        <Link className="btn btn-link btn-inner mt-20" to={"https://boatrentalsbrac.com/"} target="_blank">{t('seeWebpage')}</Link>
      </div>
    </div>
  )
}

export default Brb

function ContentOne() {
  return(
    <img className="image-fluid" src={brb} alt="Boat Rentals Brač" />
  );
}

function ContentTwo() {
  const { t } = useTranslation();

  return(
    <div className='innerMain mx-50'>
      <p className='mt-0'>{t('brbMainTxt')}</p>
      <Link className="btn btn-link mt-20" to={"https://boatrentalsbrac.com/"} target="_blank">{t('seeWebpage')}</Link>
      <h2 className='mt-50 mb-0'>{t('mainProblem')}</h2>
      <p className='problem'><Trans i18nKey="brbMainText2">
        The main problem to solve was: <br/><i>How to best present the boats for rentals in Brač area.</i>
      </Trans></p>
    </div>
  );
}